import { useContext } from 'react';
import { AuthContext } from './authContext';
import type { AuthContextValue } from './authTypes';

/**
 * Access the auth session (status, user, login, logout).
 *
 * Throws when used outside {@link AuthProvider} so mis-wiring fails loudly rather
 * than silently returning a stale default.
 */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return value;
}
